import { NgModule } from '@angular/core';

import { SharedModule } from '../../../shared';
import { ClienteTypeaheadSharedModule } from '../../pessoa/cliente/typeahead';

import { ClienteCarteiraBaixarModalComponent } from './modal';

@NgModule({
    imports: [
        SharedModule,
        ClienteTypeaheadSharedModule
    ],
    declarations: [
        ClienteCarteiraBaixarModalComponent
    ],
    exports: [
        SharedModule,

        ClienteCarteiraBaixarModalComponent
    ],
    providers: [ ]
})
export class ClienteCarteiraBaixarModule { }
